import React from "react";

const ArrowLeftLine = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M9.656 15.556H34v4H9.656l10.728 10.727-2.828 2.828L2 17.556 17.556 2l2.828 2.828L9.656 15.556z"
            fill={fill}
        />
    </svg>
);

export default ArrowLeftLine;
